import { func, object, string } from 'prop-types';
import React from 'react';

import FSMCInfo from 'routes/Documents/routes/Scores/components/FSMCInfo';
import MSNQInfo from 'routes/Documents/routes/Scores/components/MSNQInfo';
import FormDialog from '../FormDialog';
import calculateFSMCTotals from 'routes/Documents/routes/Scores/calculateFSMC';
import calculateMSNQTotals from 'routes/Documents/routes/Scores/calculateMSNQ';

const InfoDialog = ({ type, document, fm }) => {
  const [open, setOpen] = React.useState(false);
  const infoDocument = type === 'fsmc' ? calculateFSMCTotals([document])[0] : calculateMSNQTotals([document])[0];

  const infoComponent = type === 'fsmc' ? <FSMCInfo document={infoDocument} /> : <MSNQInfo document={infoDocument} />;

  return (
    <React.Fragment>
      <a href="#" onClick={() => setOpen(true)}>
        {fm('onlineRehabilitation.openFeedback')}
      </a>
      <FormDialog
        dialogOpen={open}
        type={type}
        infoComponent={infoComponent}
        closeCallback={() => setOpen(false)}
        fm={fm}
      />
    </React.Fragment>
  );
};

InfoDialog.propTypes = {
  type: string,
  document: object,
  fm: func,
};

export default InfoDialog;
